import { fromJS } from 'immutable';
import trim from 'lodash/trim';

import { messages as m, SearchConstants, SearchKeys, SearchScopes } from './constants';
import * as D from './deps';

function getNormalizedType(type: $TSFixMe) {
  if (type === D.PandoraTypes.COMPOSER) {
    return D.PandoraTypes.ARTIST;
  }

  return type;
}

export function parseSearchResultItems(data: $TSFixMe) {
  const items: $TSFixMe = [];
  let artists = 0;
  let genres = 0;
  let tracks = 0;
  let albums = 0;
  let playlists = 0;
  let stations = 0;
  let podcasts = 0;

  data.results.forEach((resultCode: $TSFixMe) => {
    let item = data.annotations[resultCode];
    let count = 0;
    const state = D.getStore().getState();
    let isShuffleStation = false;
    let stationId;

    if (item) {
      const normalizedType = getNormalizedType(item.type);
      if ([D.PandoraTypes.STATION, D.PandoraTypes.USER_STATION].includes(normalizedType)) {
        const station = D.getInDomain('playback.utils.createGetStationByPandoraIdSelector')(state)(
          item.pandoraId,
        );
        if (D.getInDomain('playback.utils.getShuffleStationId')(state) === stationId) {
          isShuffleStation = true;
        }
        if (station) {
          item = station.toJS();
        }
      }
      const imageUrl = D.Utils.Art.getArt(fromJS(item), 90, state);

      if (item.type === D.PandoraTypes.ARTIST) {
        artists++;
      } else if (item.type === D.PandoraTypes.GENRE) {
        genres++;
      } else if (item.type === D.PandoraTypes.SONG) {
        tracks++;
      } else if (item.type === D.PandoraTypes.ALBUM) {
        albums++;
      } else if (item.type === D.PandoraTypes.STATION) {
        stations++;
      } else if (item.type === D.PandoraTypes.PLAYLIST) {
        playlists++;
      } else if (item.type === D.PandoraTypes.PODCAST || item.type === D.PandoraTypes.EPISODE) {
        podcasts++;
      }

      items.push({
        artUrl: imageUrl,
        backstageUrl: item.shareableUrlPath,
        id: item.pandoraId,
        index: count++,
        name: isShuffleStation ? SearchConstants.SHUFFLE : item.name,
        type: normalizedType,
        normalizedType,
        relativeIndex: count,
        artistName: item.artistName,
        trackCount: item.trackCount || item.totalTracks,
        duration: item.duration,
        explicitness: item.explicitness,
        seedId: item.seedId || '',
        rightsInfo: item.rightsInfo,
        albumId: item.albumId,
        artistId: item.artistId,
        stationId: isShuffleStation ? stationId : item.stationId,
        hasCuratedModes: item.hasCuratedModes,
        hasTakeoverModes: item.hasTakeoverModes,
        // Podcasts
        episodeCount: item.episodeCount,
        publisherId: item.publisherId,
        publisherName: item.publisherName,
        podcastId: item.podcastId,
        programName: item.programName,
        releaseDate: item.releaseDate,
        summary: item.summary,
      });
    }
  });

  return {
    results: items,
    numResults: {
      all: items.length,
      artist: artists,
      genre: genres,
      track: tracks,
      album: albums,
      station: stations,
      playlist: playlists,
      podcast: podcasts,
    },
    annotations: data.annotations,
    searchToken: data.searchToken,
  };
}

export function getTypesForSearchScope(scope: $TSFixMe) {
  switch (scope) {
    case SearchScopes.ALL:
      // We are not using StationTypes for ALL as ALL does not search all stations.
      return [
        D.PandoraTypes.ALBUM,
        D.PandoraTypes.ARTIST,
        D.PandoraTypes.COMPOSER,
        D.PandoraTypes.SONG,
        D.PandoraTypes.STATION,
        D.PandoraTypes.PLAYLIST,
        D.PandoraTypes.USER_STATION,
        D.PandoraTypes.PODCAST,
        D.PandoraTypes.EPISODE,
      ];
    case SearchScopes.ARTISTS:
      return [D.PandoraTypes.ARTIST, D.PandoraTypes.COMPOSER];
    case SearchScopes.ALBUMS:
      return [D.PandoraTypes.ALBUM];
    case SearchScopes.STATIONS:
      return D.StationTypes;
    case SearchScopes.SONGS:
      return [D.PandoraTypes.SONG];
    case SearchScopes.PLAYLISTS:
      return [D.PandoraTypes.PLAYLIST];
    case SearchScopes.PODCASTS:
      return [D.PandoraTypes.PODCAST, D.PandoraTypes.EPISODE];
    case SearchScopes.VARIETY:
      return [D.PandoraTypes.SONG, D.PandoraTypes.ARTIST, D.PandoraTypes.COMPOSER];
  }

  return [];
}

export function determineFocusedSearchPlaceholder(state: $TSFixMe, showColdStart: $TSFixMe) {
  const isSearchActive = state.searchT3.getIn([SearchKeys.MAIN_SEARCH, SearchKeys.SEARCH_ACTIVE]);

  let placeholder = showColdStart ? m.welcomeInputPlaceHolder : m.placeholderDefault;
  if (!isSearchActive) {
    placeholder = m.focusedPlaceholderDefault;
  } else {
    placeholder = m.searchPlaceHolderPremiumAccess;
  }

  return placeholder;
}

export function determineSearchPlaceholder(
  state: $TSFixMe,
  showColdStart: $TSFixMe,
  isCenterPageSearch: $TSFixMe,
) {
  const isSearchActive = state.searchT3.getIn([SearchKeys.MAIN_SEARCH, SearchKeys.SEARCH_ACTIVE]);

  let placeholder = showColdStart ? m.welcomeInputPlaceHolder : m.placeholderDefault;
  if (showColdStart || isCenterPageSearch) {
    placeholder = m.focusedPlaceholderDefault;
  } else if (!isSearchActive) {
    placeholder = m.searchPlaceHolderPremiumAccess;
  }

  return placeholder;
}

export function isValidSearchTerm(term: $TSFixMe) {
  // The backend will interpret a string of periods as a wildcard (strangely enough) and a url of '/search/./all` is rejected
  return (term.length > 0 && trim(term, '.').length > 0) || term.length === 0;
}

export function convertToValidSearchTerm(term: $TSFixMe) {
  return trim(term, '.');
}
